<template>
  <form class="rnr-form">
    <rnr-form-item v-for="(val, key) in schema" :key="key" :class="val.border === 'none' ? '' : 'van-hairline--bottom'">
      <template #default="callback">
        <slot v-if="val.slot" :name="val.slot" />
        <component
          v-else
          :value="formData[key]"
          :is="val.type"
          :ref="`${key}Ref`"
          :label="val.label"
          :attrs="val.attrs"
          :options="val.options"
          :rules="val.rules"
          :max-count="val.maxCount"
          :validate-callback="callback"
          :min-date="val.minDate"
          :max-date="val.maxDate"
          :compress="val.compress"
          :size="val.size"
          :api="val.api"
          :itype="val.itype"
          v-on="schema.on"
          @input="val => handleComponentInput(key, val)"
        >{{ val.tip }}</component>
      </template>
    </rnr-form-item>
  </form>
</template>

<script>
import RnrFormItem from './form-item'
import RnrPicker from './picker'
import RnrFile from './file'
import RnrSelect from './select'
import RnrInput from './input'
import RnrIdcard from './idcard'
import RnrOthercard from './othercard.vue'
import RnrDatePicker from './date-picker'

export default {
  name: 'FormRender',
  components: {
    RnrFormItem,
    RnrDatePicker,
    RnrPicker,
    RnrSelect,
    RnrInput,
    RnrIdcard,
    RnrOthercard,
    RnrFile
  },
  props: {
    schema: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: Object.keys(this.schema).reduce((memo, key) => {
        memo[key] = this.schema[key].default || this.value[key]
        return memo
      }, { ...(this.value || {}) })
    }
  },
  watch: {
    /**
     * 监听输入值的变化
     */
    value: {
      handler() {
        // 表格填写的数据
        const formData = this.formData
        // 如果当前值被清空了，则需要清空所有值
        if (!this.value) {
          Object.keys(formData).forEach(key => {
            formData[key] = undefined
          })
        } else {
          Object.keys(this.value).forEach(key => {
            this.$set(formData, key, this.value[key])
          })
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * 校验所有参数
     */
    validate() {
      // 校验结果
      let result = true
      // 校验所有输入项
      Object.keys(this.schema).forEach(key => {
        // 当前引用
        const ref = this.$refs[`${key}Ref`]
        // 开始校验
        if (ref instanceof Array) {
          result = result && ref[0].validate()
        } else if (ref instanceof Object) {
          result = result && ref.validate()
        }
      })
      // 如果校验结果是失败的
      if (!result) {
        throw new Error('数据校验失败')
      }
      // 返回校验结果
      return result
    },

    /**
     * 校验指定参数
     */
    clearValidate(key) {
      // 当前引用
      const ref = this.$refs[`${key}Ref`]
      // 开始校验
      if (ref instanceof Array) {
        ref[0].clearValidate()
      } else if (ref instanceof Object) {
        ref.clearValidate()
      }
    },

    validateByKey(key) {
      // 校验结果
      let result = true
      // 当前引用
      const ref = this.$refs[`${key}Ref`]
      // 开始校验
      if (ref instanceof Array) {
        result = result && ref[0].validate()
      } else if (ref instanceof Object) {
        result = result && ref.validate()
      }
      // 返回校验结果
      return result
    },

    /**
     * 组件输入方法
     * @param value 当前输入值
     */
    handleComponentInput(key, value) {
      // 将值塞到表单中
      this.$set(this.formData, key, value)
      // 浅拷贝一下对象
      const formDataCopy = { ...this.formData }
      // 开始双向绑定
      this.$emit('input', formDataCopy)
      // 当前改变的key也带出去
      this.$emit('change', formDataCopy, key)
    }
  }
}
</script>

<style lang="scss">
.rnr-form {
  .van-field {
    background-color: transparent;
    padding: 44px 0;
    position: relative;
    &.van-cell {
      background-color: transparent;
      padding: 0;

      &.van-field {
        background-color: transparent;
        padding: 44px 0;
        position: relative;
        .van-field__label {
          color: #242424;
          font-size: 32px;
          font-weight: 400;
          height: 45px;
        }
        .van-cell__value {
          height: 45px;
          .van-field__control {
            color: #242424;
            font-size: 32px;
          }
          &.van-field__value {
            position: relative;
            .van-field__error-message {
              position: absolute;
              left: -220px;
              bottom: -90px;
            }
          }
        }
      }
      &.van-cell--required {
        .van-cell__title {
          >span {
            padding-left: 20px;
          }
        }
        &:before {
          left: 0px;
          font-size: 16px;
        }
      }
      .van-cell__title {
        >span {
          color: #242424;
          font-size: 32px;
          font-weight: 400;
        }
      }
      .van-cell__label {
        margin-top: 36px;
      }
    }
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: -50% !important;
      bottom: -50% !important;
      left: -50% !important;
      top: -50% !important;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scale(.5, .5) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormRender/index.vue